import { useEffect } from 'react';

export const BACKOFFICE_APP_TITLE = 'Nava Backoffice';

export function formatBackofficePageTitle(contextTitle?: string | null): string {
  const context = contextTitle?.trim();
  return context ? `${context} | ${BACKOFFICE_APP_TITLE}` : BACKOFFICE_APP_TITLE;
}

export function useBackofficePageTitle(contextTitle?: string | null) {
  useEffect(() => {
    document.title = formatBackofficePageTitle(contextTitle);
  }, [contextTitle]);
}
